import { Nullable } from '@/types/utility';
import { envVariables } from '@/utils/envHelpers';
import { compareVersions, validate } from 'compare-versions';

type Version = string | number[];

const isCommitHash = (value: Nullable<Version>) =>
  typeof value === 'string' && /^dev-\w{6,}$/.test(value);

export default class VersionHelper {
  public static get clientVersion() {
    return envVariables.APP_VERSION;
  }

  /***
   * To compare two versions in format "1.20.3" or [1, 20, 3] or commit hash like "dev-12345678".
   *
   * Result will be true if commit hashes are different.
   */
  static greaterThan(a: Nullable<Version>, b: Nullable<Version>): boolean {
    if (!a || !a.length || !b || !b.length) {
      return false;
    }

    if (isCommitHash(a) || isCommitHash(b)) {
      return a !== b;
    }

    const aParsed = typeof a === 'string' ? a : a.join('.');
    const bParsed = typeof b === 'string' ? b : b.join('.');

    if (validate(aParsed) && validate(bParsed)) {
      return compareVersions(aParsed, bParsed) === 1;
    }

    throw new Error('Version is invalid! Should be a valid semver version!');
  }
}
